export enum AnswerTypeHistory {
    MANAGE_SOLUTION = 'MANAGE_SOLUTION',
    MANAGE_QUOTE = 'MANAGE_QUOTE',
    QUOTE = "QUOTE",
    REQUEST_QUOTES = "REQUEST_QUOTES",
    SOLUTION = "SOLUTION",
    FINISH = "FINISH",
    WAITING = "WAITING",
    COMMENT_INSTRUCTON = "COMMENT_INSTRUCTON"
}